/** Hour-aligned clock formatting shared by `TimelineScrubber`'s readouts. */

export const HOUR_MS = 60 * 60 * 1000;

/** Zeroes out minutes/seconds/ms in the given time frame (UTC or local). */
export function floorToHour(date: Date, utc: boolean): Date {
  const floored = new Date(date);
  if (utc) {
    floored.setUTCMinutes(0, 0, 0);
  } else {
    floored.setMinutes(0, 0, 0);
  }
  return floored;
}

/** Formats an hour-aligned `Date` as "HH:00 UTC" or "HH:00 <local tz>". */
export function formatHour(date: Date, utc: boolean): string {
  return utc
    ? `${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'UTC' })} UTC`
    : date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZoneName: 'short',
      });
}
